import React from 'react';
import { Link } from 'react-router-dom';
import HomeTimer from '../HomeTimer';
import Measure from '../Measure';
import Scroll from '../Scroll';

function wrapperStyle({ styles }) {
  return {
    ...styles.toEdgeStyle
  };
}

function instructionsWrapperStyle({ color }) {
  return {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: '100%',
    paddingTop: 96,
    backgroundColor: color.blue.a700
  };
}

function faderStyle({ scroll }) {
  const { y } = scroll;
  let opacity = (y - 100) / 100;

  if (opacity < 0) {
    opacity = 0;
  }

  const style = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: '100%',
    opacity,
    backgroundColor: 'rgba(0,0,0,0.6)'
  };

  return style;
}

function vendorWrapperStyle({ constants }) {
  return {
    position: 'absolute',
    top: constants.HOME_VENDOR_MARGIN,
    left: constants.HOME_VENDOR_MARGIN
  };
}

function vendorWelcomeStyle({ constants, color, styles }) {
  return {
    ...styles.fontStyle,
    color: color.white,
    fontSize: constants.HOME_VENDOR_WELCOME_FONT_SIZE,
    marginBottom: constants.HOME_VENDOR_WELCOME_MARGIN_BOTTOM
  };
}

function vendorLogoStyle({ vendor, constants }) {
  return {
    width: constants.HOME_VENDOR_LOGO_SIZE,
    height: constants.HOME_VENDOR_LOGO_SIZE,
    backgroundRepeat: 'norepeat',
    backgroundSize: 'cover',
    backgroundImage: `url('${vendor.logo.url}')`
  };
}

function instructionsStyle({ constants, color, styles }) {
  return {
    ...styles.fontStyle,
    fontSize: constants.HOME_INSTRUCTIONS_FONT_SIZE,
    fontWeight: 300,
    paddingLeft: constants.HOME_INSTRUCTIONS_PADDING_HORIZONTAL,
    paddingRight: constants.HOME_INSTRUCTIONS_PADDING_HORIZONTAL,
    marginTop: constants.HOME_INSTRUCTIONS_MARGIN_TOP,
    letterSpacing: -2,
    color: color.white,
    textAlign: 'center'
  };
}

function buttonWrapperStyle({ dimensions, constants }) {
  return {
    marginTop: dimensions.height - constants.HOME_BUTTON_LIST_ITEM_HEIGHT - 144,
    position: 'relative'
  };
}

function buttonInstructionStyle({ styles, color, constants }) {
  const style = {
    ...styles.fontStyle,
    color: color.white,
    textAlign: 'center',
    marginBottom: constants.HOME_BUTTON_INSTRUCTION_MARGIN_BOTTOM,
    fontSize: constants.HOME_BUTTON_INSTRUCTION_FONT_SIZE
  };

  return style;
}

function buttonListStyle({ dimensions, constants, styles }) {
  return Object.assign({}, styles.centerStyle, {
    maxWidth:
      dimensions.width -
      constants.HOME_BUTTON_LIST_PADDING -
      constants.HOME_BUTTON_LIST_PADDING,
    overflow: 'hidden',
    margin: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'left',
    paddingBottom: constants.HOME_BUTTON_LIST_PADDING
  });
}

function buttonStyle({ constants, color, styles, dimensions }) {
  return {
    ...styles.fontStyle,
    backgroundColor: color.white,
    color: color.black,
    height: constants.HOME_BUTTON_LIST_ITEM_HEIGHT,
    lineHeight: `${constants.HOME_BUTTON_LIST_ITEM_HEIGHT}px`,
    textAlign: 'center',
    borderRadius: constants.HOME_BUTTON_LIST_ITEM_BORDER_RADIUS,
    float: 'left',
    fontSize: constants.HOME_BUTTON_LIST_ITEM_FONT_SIZE,
    textDecoration: 'none',
    margin: constants.HOME_BUTTON_LIST_ITEM_MARGIN,
    width:
      (dimensions.width -
        constants.HOME_BUTTON_LIST_PADDING * 2 -
        constants.HOME_BUTTON_LIST_ITEM_MARGIN * 6) /
      3, // eslint-disable-line
    boxSizing: 'border-box'
  };
}

export default props => (
  <div style={wrapperStyle(props)}>
    <HomeTimer
      requestVendor={props.requestVendor}
      vendorId={props.match.params.vendorId}
    />
    <Measure styles={props.styles} onChange={props.updateDimensions} />
    <Scroll onChange={props.updateScroll} />
    <div style={instructionsWrapperStyle(props)}>
      <div style={vendorWrapperStyle(props)}>
        <div style={vendorWelcomeStyle(props)}>
          {props.text.HOME_VENDOR_WELCOME}
        </div>
        <div style={vendorLogoStyle(props)} />
      </div>
      <div style={instructionsStyle(props)}>{props.text.HOME_INSTRUCTIONS}</div>
    </div>
    <div style={faderStyle(props)} />
    <div style={buttonWrapperStyle(props)}>
      <div style={buttonInstructionStyle(props)}>Swipe up for more</div>
      <div style={buttonListStyle(props)}>
        {props.vendor.signs.map((sign, index) => (
          <Link
            to={`/sign/${props.match.params.vendorId}/${sign.id}`}
            style={buttonStyle(props)}
            key={index}
          >
            {sign.name}
          </Link>
        ))}
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Home/index.js